export default "__VITE_ASSET__AFOsTiiY__"